export default {
  countries: (state) => state.countries,
  country: (state) => state.country,
};
